import { useMemo } from 'react';
import { useRouter } from 'next/router';
import _includes from 'lodash/includes';
import _split from 'lodash/split';
import {
  checkDomestic,
  checkEconomyCabin,
  checkMultiCity,
  getParsedSearchQuery,
  checkRoundTrip,
  replacePaxInQuery,
  getRouteFromQuery,
  getCabinTypeFromQuery,
  checkOneWay,
  getSearchTypeFromQuery,
  checkDomesticKSA,
} from '@tajawal/web-flights-sdk/lib/utils/search.utils';

export function useQuery(baseQuery?: string) {
  const router = useRouter();
  const params = router.query.query as string[];
  const isGoogleFlightRedirect = router.query.googleFlights === '1';
  const isMobile = _includes(router.pathname, '/mweb/');

  const {
    isDomestic,
    isEconomy,
    isMultiCity,
    parsedSearchQuery,
    joinedParams,
    query,
    isRoundTrip,
    adult = 1,
    child = 0,
    infant = 0,
    totalPax = 1,
    route,
    tripType,
    cabinType,
    originId,
    destinationId,
    isOneWay,
    isDomesticKSA,
  } = useMemo(() => {
    const joinedParams = typeof params === 'string' ? params : params?.join('/');
    const query = baseQuery || joinedParams;
    const parsedSearchQuery = getParsedSearchQuery(query);
    const { adult, child, infant } = parsedSearchQuery;
    const paxQuery = `${adult}Adult${child ? `/${child}Child` : ''}${infant ? `/${infant}Infant` : ''}`;
    const validatedQuery = replacePaxInQuery(query, paxQuery);
    const route = getRouteFromQuery(validatedQuery);
    const [originId, destinationId] = _split(route, '-');

    return {
      joinedParams,
      isDomesticKSA: checkDomesticKSA(validatedQuery),
      isDomestic: checkDomestic(validatedQuery),
      isEconomy: checkEconomyCabin(validatedQuery),
      isMultiCity: checkMultiCity(validatedQuery),
      parsedSearchQuery,
      query: validatedQuery,
      isRoundTrip: checkRoundTrip(validatedQuery),
      isOneWay: checkOneWay(validatedQuery),
      adult,
      child,
      infant,
      route: getRouteFromQuery(validatedQuery),
      cabinType: getCabinTypeFromQuery(validatedQuery),
      tripType: getSearchTypeFromQuery(validatedQuery),
      totalPax: adult + child + infant,
      originId,
      destinationId,
    };
  }, [params, baseQuery]);

  return {
    query,
    isRoundTrip,
    joinedParams,
    isDomestic,
    parsedSearchQuery,
    isGoogleFlightRedirect,
    isEconomy,
    isMultiCity,
    router,
    isMobile,
    adultCount: adult,
    childCount: child,
    infantCount: infant,
    totalPax,
    route,
    cabinType,
    tripType,
    originId,
    destinationId,
    isOneWay,
    isDomesticKSA,
  };
}
